export const SocialProfileStatus = [
  {
    title: "Posts",
    active: 1_908,
  },
  {
    title: "Followers",
    active: "34.0k",
  },
  {
    title: "Following",
    active: 897,
  },
];

export const SocialWidgetData = [
  {
    title: "Facebook",
    image: "1.png",
    gros: 22.9,
    total: 12_098,
    subTitle: "Followers",
    status: "success",
    chart: {
      color: ["var(--theme-default)"],
      series: [78],
    },
  },
  {
    title: "Instagram",
    image: "2.png",
    gros: 27.4,
    total: 15_080,
    subTitle: "Followers",
    status: "success",
    chart: {
      color: ["#FFA941"],
      series: [70],
    },
  },
  {
    title: "Twitter",
    image: "3.png",
    gros: 14.09,
    total: 12_564,
    subTitle: "Followers",
    status: "success",
    chart: {
      color: ["#57B9F6"],
      series: [50],
    },
  },
];

export const SocialWidgetDataWidgetPage = [
  {
    title: "Facebook",
    image: "1.png",
    gros: 22.9,
    total: 12_098,
    subTitle: "Followers",
    status: "success",
    chart: {
      color: ["var(--theme-default)"],
      series: [78],
    },
  },
  {
    title: "Instagram",
    image: "2.png",
    gros: 27.4,
    total: 15_080,
    subTitle: "Followers",
    status: "success",
    chart: {
      color: ["#FFA941"],
      series: [70],
    },
  },
  {
    title: "Twitter",
    image: "3.png",
    gros: 14.09,
    total: 12_564,
    subTitle: "Followers",
    status: "success",
    chart: {
      color: ["#57B9F6"],
      series: [50],
    },
  },
  {
    title: "Youtube",
    image: "4.png",
    gros: 14.09,
    total: 68_954,
    subTitle: "Followers",
    status: "secondary",
    chart: {
      color: ["var(--theme-secondary)"],
      series: [80],
    },
  },
];

export const SmallWidgetsData = [
  {
    title: "Photo Clicks",
    total: 76,
    gros: 72.9,
    chart: {
      series: [
        {
          name: "photo",
          data: [10, 12, 41, 36, 60, 58],
        },
      ],
      color: "#54BA4A",
    },
  },
  {
    title: "Link Clicks",
    total: 89,
    gros: 79.9,
    chart: {
      series: [
        {
          name: "photo",
          data: [10, 12, 41, 36, 60, 58],
        },
      ],
      color: "var(--theme-secondary)",
    },
  },
];

export const AllCampaignsTable = {
  header: ["AD Platform", "Campaign", "GEO", "Profitability", "Max Participation Avai.", "Status", "Create"],
  body: [
    {
      ADPlatform: "facebook",
      icon: "facebook",
      campaign: "Jane Cooper",
      GEO: "UK",
      profitability: 45.6,
      maxParticipation: 9_786,
      status: "Active",
    },
    {
      ADPlatform: "instagram",
      icon: "instagram",
      campaign: "Floyd Miles",
      GEO: "DE",
      profitability: 12.3,
      maxParticipation: 19_7098,
      status: "Active",
    },
    {
      ADPlatform: "pinterest",
      icon: "pinterest",
      campaign: "Guy Hawkins",
      GEO: "ES",
      profitability: 65.6,
      maxParticipation: 90_986,
      status: "Active",
    },
    {
      ADPlatform: "twitter",
      icon: "twitter",
      campaign: "Travis Wright",
      GEO: "ES",
      profitability: 35.6,
      maxParticipation: 23_654,
      status: "Inactive",
    },
    {
      ADPlatform: "you-tube",
      icon: "youtube-play",
      campaign: "Mark Green",
      GEO: "UK",
      profitability: 45.6,
      maxParticipation: 12_796,
      status: "Inactive",
    },
  ],
};
